module.exports = __webpack_public_path__ + "img/file-lock.c9dd716b.svg";